// extracted by mini-css-extract-plugin
module.exports = {"RelatedProducts":"RelatedProducts_RelatedProducts__qo5_I","title":"RelatedProducts_title__zT3NC","text":"RelatedProducts_text__VIosS","grid":"RelatedProducts_grid__grkJC"};